import { Observable } from 'rxjs'
import { push } from 'react-router-redux'
import { apiUrl } from '../config/settings'
import { teamTypes, errorTypes, popupTypes, generalTypes, socketTypes, participantTypes } from '../actions'
import { Headers, Auth } from '../helpers'

export const registerEpic = (action$) => {
  return action$.ofType(teamTypes.REGISTER)
    .switchMap(action => {
      return Observable
        .ajax(
          {
            url: `${apiUrl}/teams/create`,
            method: 'POST',
            headers: Headers.getWithAuth(),
            body: action.data
          }
        )
        .map(res => ({ type: teamTypes.REG_RESPONSE, payload: res.response }))
        .catch(err => window.alert(err))
    })
}

export const regResponseEpic = (action$) => {
  return action$.ofType(teamTypes.REG_RESPONSE)
    .switchMap(action => {
      return Observable
        .create(obs => {
          const { success } = action.payload
          if (success) {
            const { team } = action.payload
            obs.next({ type: teamTypes.REG_SUCCESS, team })
            obs.next({ type: teamTypes.SAVE_MINE, team })
            obs.next(push('/myteam'))
          } else {
            if (action.payload.err.code === 11000) {
              obs.next({ type: generalTypes.DISPLAY_ALERT, text: 'Team Name is already in use.' })
            } else {
              obs.next({ type: generalTypes.DISPLAY_ALERT, text: action.payload.err.errmsg })
            }
          }
          obs.complete()
        })
        .catch(err => window.alert(err))
    })
}

export const manageEpic = (action$) => {
  return action$.ofType(teamTypes.MANAGE)
    .switchMap(action => {
      return Observable
        .ajax(
          {
            url: `${apiUrl}/teams/manage`,
            method: 'POST',
            headers: Headers.getWithAuth(),
            body: action.data
          }
        )
        .map(res => ({ type: teamTypes.MANAGE_RES, payload: res.response }))
        .catch(err => window.alert(err))
    })
}

export const manageResEpic = (action$) => {
  return action$.ofType(teamTypes.MANAGE_RES)
    .switchMap(action => {
      return Observable
        .create(obs => {
          const { success } = action.payload
          if (success) {
            const { team } = action.payload
            team.id === Auth.getMyTeamId() && obs.next({ type: teamTypes.SAVE_MINE, team })
            obs.next({ type: teamTypes.UPDATE, team })
            team.id === Auth.getMyTeamId() && obs.next(push('/myteam'))
          } else {
            if (action.payload.err.code === 11000) {
              obs.next({ type: generalTypes.DISPLAY_ALERT, text: 'Team Name is already in use.' })
            } else {
              obs.next({ type: generalTypes.DISPLAY_ALERT, text: action.payload.err.errmsg })
            }
          }
          obs.complete()
        })
        .catch(err => window.alert(err))
    })
}

export const getMineEpic = (action$) => {
  return action$.ofType(teamTypes.GET_MINE)
    .switchMap(() => {
      return Observable
        .ajax(
          {
            url: `${apiUrl}/teams/mine`,
            method: 'GET',
            headers: Headers.getWithAuth()
          }
        )
        .map(res => ({ type: teamTypes.GET_MINE_RESPONSE, payload: res.response }))
        .catch(err => window.alert(err))
    })
}

export const getMineResponse = (action$) => {
  return action$.ofType(teamTypes.GET_MINE_RESPONSE)
    .switchMap(action => {
      return Observable
        .create(obs => {
          const { success } = action.payload
          if (success) {
            const { myTeam } = action.payload
            obs.next({ type: teamTypes.SAVE_MINE, team: myTeam })
            obs.complete()
          }

          obs.next({ type: errorTypes.DISPLAY, err: action.payload.err })
        })
        .catch(err => window.alert(err))
    })
}

export const getSingleEpic = (action$) => {
  return action$.ofType(teamTypes.GET_SINGLE)
    .switchMap(action => {
      return Observable
        .ajax(
          {
            url: `${apiUrl}/teams/${action.id}`,
            method: 'GET',
            headers: Headers.getWithAuth()
          }
        )
        .map(res => ({ type: teamTypes.GET_SINGLE_RES, payload: res.response }))
        .catch(err => window.alert(err))
    })
}

export const getSingleResEpic = (action$) => {
  return action$.ofType(teamTypes.GET_SINGLE_RES)
    .switchMap(action => {
      return Observable
        .create(obs => {
          const { success } = action.payload
          if (success) {
            let { team } = action.payload
            let { participants } = team
            team.participants = participants.map(p => p.id)

            obs.next({ type: teamTypes.UPDATE, team })
            participants.forEach(participant => {
              obs.next({ type: participantTypes.UPDATE, participant })
            })
          } else {
            obs.next({ type: errorTypes.DISPLAY, err: action.payload.err.message })
          }
          obs.complete()
        })
        .catch(err => window.alert(err))
    })
}

export const getAllEpic = (action$) => {
  return action$.ofType(teamTypes.GET_ALL)
    .switchMap(() => {
      return Observable
        .ajax(
          {
            url: `${apiUrl}/teams/`,
            method: 'GET',
            headers: Headers.getWithAuth()
          }
        )
        .map(res => ({ type: teamTypes.GET_ALL_RESPONSE, payload: res.response }))
        .catch(err => window.alert(err))
    })
}

export const getAllResponseEpic = (action$) => {
  return action$.ofType(teamTypes.GET_ALL_RESPONSE)
    .switchMap(action => {
      return Observable
        .create(obs => {
          const { success } = action.payload
          if (success) {
            let { teams } = action.payload
            const myTeam = teams.find(t => t.id === Auth.getMyTeamId()) || Auth.getMyTeamId()
            obs.next({ type: teamTypes.SAVE_MINE, team: myTeam })
            obs.next({ type: teamTypes.SAVE_TEAMS, teams })
            obs.complete()
          }

          obs.next({ type: errorTypes.DISPLAY, err: action.payload.err })
        })
        .catch(err => window.alert(err))
    })
}

export const joinEpic = (action$) => {
  return action$.ofType(teamTypes.JOIN)
    .switchMap(action => {
      return Observable
        .ajax(
          {
            url: `${apiUrl}/teams/join/${action.id}`,
            method: 'GET',
            headers: Headers.getWithAuth()
          }
        )
        .map(res => ({ type: teamTypes.JOIN_RESPONSE, payload: res.response }))
        .catch(err => window.alert(err))
    })
}

export const joinResponseEpic = (action$) => {
  return action$.ofType(teamTypes.JOIN_RESPONSE)
    .switchMap(action => {
      return Observable
        .create(obs => {
          const { success } = action.payload
          if (success) {
            const { team } = action.payload
            obs.next({ type: teamTypes.SAVE_MINE, team })
            obs.next({ type: popupTypes.SWITCH_NOTIFICATION, payload: {} })
            obs.next({ type: generalTypes.DISPLAY_ALERT, text: 'Successful operation.' })
          } else {
            obs.next({ type: generalTypes.DISPLAY_ALERT, text: action.payload.err })
          }
          obs.complete()
        })
        .catch(err => window.alert(err))
    })
}

export const deleteEpic = (action$) => {
  return action$.ofType(teamTypes.DELETE)
    .switchMap(action => {
      return Observable
        .ajax(
          {
            url: `${apiUrl}/teams/delete/${action.id}`,
            method: 'GET',
            headers: Headers.getWithAuth()
          }
        )
        .map(res => ({ type: teamTypes.DELETE_RESPONSE, payload: res.response }))
        .catch(err => window.alert(err))
    })
}

export const deleteResponseEpic = (action$) => {
  return action$.ofType(teamTypes.DELETE_RESPONSE)
    .switchMap(action => {
      return Observable
        .create(obs => {
          const { success } = action.payload
          if (success) {
            obs.next({ type: socketTypes.REMOVED_FROM_TEAM })
            obs.next({ type: popupTypes.SWITCH_DELETE_TEAM })
            obs.next(push('/'))
            obs.next({ type: generalTypes.DISPLAY_ALERT, text: 'Team deleted. Please reload the page.' })
          } else {
            obs.next({ type: generalTypes.DISPLAY_ALERT, text: action.payload.err })
          }
          obs.complete()
        })
        .catch(err => window.alert(err))
    })
}

export const changeStatusEpic = (action$) => {
  return action$.ofType(teamTypes.CHANGE_STATUS)
    .switchMap(action => {
      return Observable
        .ajax(
          {
            url: `${apiUrl}/admin/teamchange`,
            method: 'POST',
            headers: Headers.getWithAuth(),
            body: action.data
          }
        )
        .map(res => ({ type: teamTypes.CHANGE_STATUS_RES, payload: res.response }))
        .catch(err => window.alert(err))
    })
}

export const changeStatusResEpic = (action$) => {
  return action$.ofType(teamTypes.CHANGE_STATUS_RES)
    .switchMap(action => {
      return Observable
        .create(obs => {
          const { success } = action.payload
          if (success) {
            const { team } = action.payload
            obs.next({ type: teamTypes.UPDATE, team })
          } else {
            obs.next({ type: generalTypes.DISPLAY_ALERT, text: action.payload.err.errmsg })
          }
          obs.complete()
        })
        .catch(err => window.alert(err))
    })
}

export const changeLocationEpic = (action$) => {
  return action$.ofType(teamTypes.CHANGE_LOCATION)
    .switchMap(action => {
      return Observable
        .ajax(
          {
            url: `${apiUrl}/admin/changelocation`,
            method: 'POST',
            headers: Headers.getWithAuth(),
            body: action.data
          }
        )
        .map(res => ({ type: teamTypes.CHANGE_LOCATION_RES, payload: res.response }))
        .catch(err => window.alert(err))
    })
}

export const changeLocationResEpic = (action$) => {
  return action$.ofType(teamTypes.CHANGE_LOCATION_RES)
    .switchMap(action => {
      return Observable
        .create(obs => {
          const { success } = action.payload
          if (success) {
            const { id } = action.payload
            obs.next({ type: teamTypes.REMOVE, id })
          } else {
            obs.next({ type: generalTypes.DISPLAY_ALERT, text: action.payload.err })
          }
          obs.complete()
        })
        .catch(err => window.alert(err))
    })
}

export const changeTeamCommentEpic = (action$) => {
  return action$.ofType(teamTypes.CHANGE_COMMENT)
    .switchMap(action => {
      return Observable
        .ajax(
          {
            url: `${apiUrl}/admin/teamcomment`,
            method: 'POST',
            headers: Headers.getWithAuth(),
            body: action.data
          }
        )
        .map(res => ({ type: teamTypes.GET_SINGLE_RES, payload: res.response }))
        .catch(err => window.alert(err))
    })
}



// WEBPACK FOOTER //
// ./src/epics/team.js